export default {
    upArrow: {
        color: 'green',
        icon: 'mdi-arrow-up-bold',
        price: {gem_emerald: 100}
    },
    expander: {
        color: 'red',
        icon: 'mdi-magnify-expand',
        unique: true,
        price: {gem_emerald: 300}
    },
    wildcard: {
        color: 'blue',
        icon: 'mdi-card-bulleted',
        price: {gem_sapphire: 300}
    },
    eventStar: {
        color: 'amber',
        icon: 'mdi-star'
    },
}
